import { Controller } from "@hotwired/stimulus"

export default class ClassToggleController extends Controller {
  static classes = ["toggle", "trigger"]
  static targets = ["element", "trigger"]

  toggle() {
    this.#applyToTargets((target, classes) =>
      classes.forEach((className) => target.classList.toggle(className))
    )
  }

  add() {
    this.#applyToTargets((target, classes) =>
      classes.forEach((className) => target.classList.add(className))
    )
  }

  remove() {
    this.#applyToTargets((target, classes) =>
      classes.forEach((className) => target.classList.remove(className))
    )
  }

  preventClassMorphing(event) {
    const {
      detail: { attributeName },
    } = event

    if (attributeName == "class") {
      event.preventDefault()
    }
  }

  #applyToTargets(operation) {
    const elements = this.hasElementTarget
      ? this.elementTargets
      : [this.element]

    elements.forEach((element) => operation(element, this.toggleClasses))

    if (this.hasTriggerTarget) {
      operation(this.triggerTarget, this.triggerClasses)
    }
  }
}
